<div class="spinner-wrapper" >
  <div class="child">
    <img src="assets/images/logo/app-logo-hoz.png" width="250" height="100">
    <div class="donut"></div>
  </div>
</div>